import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InvoiceTemplatesPopupComponent } from '../../invoice-templates-popup/invoice-templates-popup.component';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { FuseConfirmDialogComponent } from '@/app/Shared/confirm-dialog/confirm-dialog.component';
import { DIALOG_WIDTH } from '@/app/_constant/dialog-width.constants';

@Component({
  selector: 'app-invoice-options',
  templateUrl: './invoice-options.component.html',
  styleUrls: ['./invoice-options.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvoiceOptionsComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  isLoadingResults: boolean = true;
  getDropDownValue: any = [];
  InvoiceValueGetData: any;
  confirmDialogRef: MatDialogRef<any>;
  activeOption = 0;
  sub: Subscription;
  sub1: Subscription;
  invoiceTempData: any[] = [];
  private _unsubscribeAll$: Subject<void> = new Subject();
  @Input() errorWarningData: any;
  constructor(
    private behaviorService: BehaviorService,
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
  ) {}

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.behaviorService.loadingSystemSetting('statements');

    this.sub = this.behaviorService.refreshTemplateOptionsList
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (callback: any) => {
          if (callback) {
            this.loadData();
          }
        },
      });

    // this.loadList();
    this.loadData();
  }

  /**
   * load the data of invoice templates
   */
  loadData() {
    this.isLoadingResults = true;
    this.sub1 = this._mainAPiServiceService
      .getSetData(
        {
          Action: 'GetData',
          Filters: { GroupName: 'InvoiceTemplates' },
        },
        'system',
      )
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && response.STATUS == 'success') {
            this.isLoadingResults = false;
            let tempData: any[] = response.DATA.RECORDS;
            this.invoiceTempData = tempData;

            let SelectedInvoiceValue: any = JSON.parse(localStorage.getItem('InvoiceDataVAlue'));

            if (SelectedInvoiceValue) {
              const index: number = tempData.findIndex(
                (x: any) => x.VALUE === SelectedInvoiceValue.VALUE,
              );

              if (index !== -1) {
                this.InvoiceValueGetData = tempData[index];
                this.activeOption = index;
              } else {
                this.InvoiceValueGetData = tempData[0];
                this.activeOption = 0;
              }
            } else {
              this.InvoiceValueGetData = tempData[0];
              this.activeOption = 0;
            }
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.toastr.error(error);
          this.isLoadingResults = false;
          this.cd.markForCheck();
        },
      });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
    this.sub1?.unsubscribe();
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
  }

  // loadList() {
  //   this._mainAPiServiceService.getSetData({ EXCLUDESYSTEMACCOUNTS: true, EXCLUDEINVOICETEMPLATESETTINGS: false }, 'GetSystem').subscribe(response => {
  //     this.getDropDownValue = response.DATA.LISTS;
  //   });
  // }

  /**
   *
   * @param value
   * @param index
   */
  InvoiceValueGet(value: any, index: number) {
    this.InvoiceValueGetData = value;
    localStorage.setItem('InvoiceDataVAlue', JSON.stringify(value));
    this.activeOption = index;
    this.cd.markForCheck();
  }

  newInvoicePopup(type: any) {
    const dialogRef = this.dialog.open(InvoiceTemplatesPopupComponent, {
      // width: DIALOG_WIDTH.FULL,
      disableClose: true,
      data: { InvoiceValueGetData: this.InvoiceValueGetData, Type: type },
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });

    dialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result: any) => {
        this.cd.markForCheck();
      });
  }

  /**
   * delete a particular invoice from list
   */
  deleteInvoicePopup() {
    this.confirmDialogRef = this.dialog.open(FuseConfirmDialogComponent, {
      disableClose: true,
      width: DIALOG_WIDTH.FULL,
      panelClass: 'dialog-panel-class',
      backdropClass: 'cdk-overlay-dark-backdrop',
    });
    this.confirmDialogRef.componentInstance.confirmMessage = 'Are you sure you want to delete?';
    this.confirmDialogRef
      .afterClosed()
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((result: any) => {
        if (result) {
          this.isLoadingResults = true;
          this.cd.markForCheck();
          this._mainAPiServiceService
            .getSetData(
              {
                FormAction: 'delete invoice template',
                Data: {
                  TemplateId: this.InvoiceValueGetData.VALUE,
                },
              },
              'system',
            )
            .pipe(takeUntil(this._unsubscribeAll$))
            .subscribe({
              next: (response: any) => {
                if (response.CODE == 200 && response.STATUS == 'success') {
                  this.toastr.success('Deleted successfully');
                  this.loadData();
                } else {
                  this.toastr.error(response.MESSAGE);
                  this.isLoadingResults = false;
                }
                this.cd.markForCheck();
              },
              error: (error: any) => {
                this.toastr.error(error);
                this.isLoadingResults = false;
                this.cd.markForCheck();
              },
            });
        }
      });
  }
}
